import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import Particle from "../Particle";
import Home2 from "./Home2";

import Type from "./Type";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <h1></h1>
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">

              <h1 className="heading-name">

                <strong className="main-name"> CHOICE COIN</strong>
              </h1>
              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
            </Col>

            <Col>
              <h2>
               <strong className="main-name">Mission</strong>
              </h2>
              <p>
              Choice Coin's mission is to foster opportunities for Open Source Software (OSS) development within the realm of decentralized governance. By providing a platform for collaboration and innovation, Choice Coin aims to empower developers worldwide to contribute to the advancement of decentralized technologies and create impactful solutions for the future.
              </p>
            </Col>
          </Row>



        </Container>
      </Container>
      <Home2 />
      
    </section>
  );
}

export default Home;
